import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Shield, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/button';

const Login = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Image */}
      <div 
        className="hidden lg:block lg:w-1/2 bg-cover bg-center relative"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1764327297100-198adc578a04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjB1cmJhbiUyMGJ1aWxkaW5nJTIwc3Vubnl8ZW58MHx8fHwxNzczMDA5NjY0fDA&ixlib=rb-4.1.0&q=85')"
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#002255]/90 to-[#002255]/70"></div>
        <div className="relative h-full flex flex-col justify-center px-12 text-white">
          <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Webuildd
          </h1>
          <p className="text-xl mb-8 text-white/90">
            Votre plateforme CRM pour le foncier et l'immobilier
          </p>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <Building2 className="w-6 h-6 mt-1 text-[#FF6600]" />
              <div>
                <h3 className="font-semibold text-lg mb-1">Gestion Complète</h3>
                <p className="text-white/80">Gérez vos contacts, opportunités et interactions en un seul endroit</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Shield className="w-6 h-6 mt-1 text-[#FF6600]" />
              <div>
                <h3 className="font-semibold text-lg mb-1">Sécurisé</h3>
                <p className="text-white/80">Vos données sont protégées avec les meilleurs standards de sécurité</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <TrendingUp className="w-6 h-6 mt-1 text-[#FF6600]" />
              <div>
                <h3 className="font-semibold text-lg mb-1">Analytics Puissants</h3>
                <p className="text-white/80">Suivez vos performances avec des statistiques détaillées</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Login Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-[#F8FAFC]">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200/40 p-8">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-[#002255] rounded-xl flex items-center justify-center mx-auto mb-4">
                <Building2 className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-bold text-[#002255] mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Bienvenue
              </h2>
              <p className="text-gray-600">
                Connectez-vous pour accéder à votre espace
              </p>
            </div>

            <Button
              data-testid="google-login-button"
              onClick={handleLogin}
              className="w-full h-12 bg-[#002255] hover:bg-[#002255]/90 text-white rounded-lg font-medium shadow-sm transition-all duration-200"
            >
              <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>
              Se connecter avec Google
            </Button>

            <p className="text-center text-sm text-gray-500 mt-6">
              En vous connectant, vous acceptez nos conditions d'utilisation
            </p>
          </div>

          <p className="text-center text-sm text-gray-500 mt-6">
            © 2026 Webuildd Foncier et Immobilier. Tous droits réservés.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
